import { Link } from 'react-router-dom';

export default function BrandMark({ compact = false }) {
  return (
    <Link
      className={'brand-mark' + (compact ? ' brand-mark-compact' : '')}
      to="/"
      aria-label="Tripzy ana sayfa"
    >
      <span className="brand-symbol" aria-hidden="true">
        T
      </span>
      <span>Tripzy</span>
    </Link>
  );
}
